export const useStyles = (theme) => ({
  root: {
    paddingLeft: 100,
    paddingRight: 100,
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
  },
  paper: {
    padding: 30,
  },
  errorStyle: {
    color: "red",
  },
});
